import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageview } from "../lib/analytics";

/**
 * Drop this once near the top of the routed tree — it fires `trackPageview`
 * on every React Router transition (respecting consent + automatically
 * capturing the previous page's duration_ms).
 */
export default function PageviewTracker() {
  const location = useLocation();
  useEffect(() => {
    trackPageview(location.pathname + (location.search || ""));
  }, [location.pathname, location.search]);
  return null;
}
